export default __webpack_public_path__ + "static/media/learners.ff202c85.svg";